import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ThemeService } from './theme.service';

@Injectable({
    providedIn: 'root',
})
export class DarkThemeService {
    enabled = false;
    light = environment.theme;
    dark = 'dark';

    constructor(private themeService: ThemeService) {
        const currentTheme = localStorage.getItem('theme');
        if (currentTheme == 'dark') {
            this.enabled = true;
            this.themeService.setTheme(this.dark);
        } else if (currentTheme == this.light) {
            this.enabled = false;
            this.themeService.setTheme(this.light);
        }
    }

    onDarkMode() {
        const prefersDarkScheme = window.matchMedia(
            '(prefers-color-scheme: dark)'
        );

        let theme;

        theme = this.themeService.toggleDark();
        this.enabled = theme == this.dark;
        // if (prefersDarkScheme.matches) {
        //   const current = this.themeService.getActiveTheme()
        //   document.body.classList.toggle("light-theme");
        //   theme = document.body.classList.contains("light-theme")
        //     ? "light"
        //     : "dark";
        // } else {
        //   document.body.classList.toggle("dark-theme");
        //   theme = document.body.classList.contains("dark-theme")
        //     ? "dark"
        //     : "light";
        // }
        localStorage.setItem('theme', theme);
    }
}
